import { useQuery } from '@tanstack/react-query';
import Fetch, { V1 } from 'Util/fetcher';

/**
 * Hook: useBonusSummary
 * --------------------------------------------
 * Wraps GET transactions/bonuses/summary/ with React-Query caching.
 */
export default function useBonusSummary(options = {}) {
  const queryKey = ['bonus-summary'];

  const queryFn = async () => {
    const resp = await Fetch.get(`${V1}transactions/bonuses/summary/`);
    if (!resp.ok) throw new Error(resp.json?.message || 'Failed to load bonus summary');
    return resp.json;
  };

  return useQuery(queryKey, queryFn, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
}
